import type { ReactNode } from 'react'

import { cn } from '@gto/ui/cn'

type ContentProps = {
  children?: ReactNode
  className?: string
}

export const Content = ({ children, className }: ContentProps) => {
  return <div className={cn('min-h-0 flex-1 py-4', className)}>{children}</div>
}
